import { Routes, Route } from 'react-router-dom';
// user registration
import Register from './pages/Auth/Register';
import Login from './pages/Auth/Login';
import ForgotPassword from './pages/Auth/ForgotPassword';
import ResetPassword from './pages/Auth/ResetPassword';

// user management
import UserList from './pages/User/UserList';
import EditUser from './pages/User/EditUser';
import CreateUser from './pages/User/CreateUser';

// ticket management
import CreateTicket from './pages/Ticket/CreateTicket';
import TicketList from './pages/Ticket/TicketList';
import ViewTicket from './pages/Ticket/ViewTicket';
import EditTicket from './pages/Ticket/EditTicket';

import Navbar from './components/Navbar';
import { useAuth } from './context/AuthContext';
import { Navigate } from 'react-router-dom';

function App() {
  const { token, loading } = useAuth();

  if (loading) return <div className="text-center mt-5">Loading...</div>;

  return (
    <div>
      <Navbar />
      <Routes>
        <Route path="/register" element={<Register />} />
        <Route path="/login" element={<Login />} />
        <Route path='/tickets' element={<TicketList />} />
        <Route path="/create-ticket" element={<CreateTicket />} />
        <Route path="/tickets/:id" element={<ViewTicket />} />
        <Route path="/tickets/edit/:id" element={<EditTicket />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password/:token" element={<ResetPassword />} /> 
        <Route path="/users" element={token ? <UserList /> : <Navigate to="/login" />} />
        <Route path="/users/create" element={token ? <CreateUser /> : <Navigate to="/login" />} />
        <Route path="/users/edit/:id" element={token ? <EditUser /> : <Navigate to="/login" />} />
      </Routes>
    </div>
  );
}

export default App;
